import { render, staticRenderFns } from "./EnrollApplication.vue?vue&type=template&id=b0c2b75a&scoped=true&"
import script from "./EnrollApplication.vue?vue&type=script&lang=js&"
export * from "./EnrollApplication.vue?vue&type=script&lang=js&"
import style0 from "./EnrollApplication.vue?vue&type=style&index=0&id=b0c2b75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c2b75a",
  null
  
)

export default component.exports